import React, { createContext, useState, useContext } from 'react';

const ProjectContext = createContext(null);

export const ProjectProvider = ({ children }) => {
  const [currentProject, setCurrentProject] = useState(() => {
    const saved = localStorage.getItem('currentProject');
    return saved ? JSON.parse(saved) : null;
  });
  const [isProjectLoading, setIsProjectLoading] = useState(false);

  const selectProject = (project) => {
    setCurrentProject(project);
    localStorage.setItem('currentProject', JSON.stringify(project));
  };

  const clearProject = () => {
    setCurrentProject(null);
  };

  return (
    <ProjectContext.Provider value={{ 
      currentProject,
      setCurrentProject,
      isProjectLoading,
      setIsProjectLoading,
      selectProject,
      clearProject
    }}>
      {children}
    </ProjectContext.Provider>
  );
};

export const useProject = () => useContext(ProjectContext); 